import { render, staticRenderFns } from "./CustomizeForm.vue?vue&type=template&id=1aaa9544&scoped=true&"
import script from "./CustomizeForm.vue?vue&type=script&lang=js&"
export * from "./CustomizeForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomizeForm.vue?vue&type=style&index=0&id=1aaa9544&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aaa9544",
  null
  
)

export default component.exports